import { render, staticRenderFns } from "./VideoSection.vue?vue&type=template&id=739129cf&scoped=true"
import script from "./VideoSection.vue?vue&type=script&lang=js"
export * from "./VideoSection.vue?vue&type=script&lang=js"
import style0 from "./VideoSection.vue?vue&type=style&index=0&id=739129cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739129cf",
  null
  
)

export default component.exports